(function () {
    'use strict';
    a3_cabin_reports.factory('BucketFactory', BucketFactory);

    /**
     * @memberof CabinReports
     * @ngdoc factory
     * @name BucketFactory
     * @description 
     * Get Duties from API 
     * @ngInject
     */
    function BucketFactory(GenericService, $http, $q, apiUrl, LogService) {

        /**
         * Initialize Bucket
         * @memberof BucketFactory
         */
        
        var service = {
            getDutyObject: getDutyObject,
            getDutyById: getDutyById,
            shareDuty: shareDuty,
            acknowledgeProposal : acknowledgeProposal,
            fetchProposal: fetchProposal,
            createProposal: createProposal,
            evaluateProposal: evaluateProposal,
            undoProposalStatus: undoProposalStatus,
            fetchSharedProposal: fetchSharedProposal
        };

      
        /**
         * Gets Bucket Calendar object
         * @memberof BucketFactory
         * @param {function} callback 
         */
        function getDutyObject(callback) {
           return $http.get(apiUrl + '/bucket/', { 'Content-Type': 'application/json' })
                .then(callback);
        }

        /**
         * Gets duty object and shared duties object for the BucketDay View
         * @memberof BucketFactory
         * @param {number} dutyId 
         * @param {function} callback 
         */
        function getDutyById(dutyId, callback){
                return $http.get(apiUrl + '/bucket/GetBucketDuty/' + dutyId, { 'Content-Type': 'application/json' })
                .then(callback);
        }
        
        /**
         * Shares/Unshares duty
         * @memberof BucketFactory
         * @param {object} duty 
         * @param {function} callback 
         * @param {function} errorCallback 
         */
        function shareDuty(duty, callback, errorCallback ){
            //todo remove when api became correct
            var dutyMinified = {
                          Id: duty.Id,
                          Shareable: duty.Shareable,
                          Shared: duty.Shared,
                          Comments: duty.Comments,
                          CrewInformation: {
                            Email: null,
                            Phone: null,
                            Comments: null
                          }
                        };

            return $http.post(apiUrl + '/bucket/ShareDuty/', dutyMinified, {'Content-Type' : 'application/json' })
            .then (callback)
            .catch(errorCallback);
        }

        /**
         * Makes proposal acknowledged 
         * @memberof BucketFactory
         * @param {number} proposalId 
         * @param {function} callback 
         */
        function acknowledgeProposal(proposalId, callback){
            return $http.get(apiUrl + '/bucket/AcknowledgeProposal?proposalId=' + proposalId, { 'Content-Type' : 'application/json' })
            .then(callback);
        }

        /**
         * Fetches proposal info 
         * @memberof BucketFactory
         * @param {number} dutyId 
         * @param {function} callback 
         * @returns {object} - Promise containing Proposed and Requested duties alongside Crew and Route details for each one
         */
        function fetchProposal(dutyId, callback){
            return $http.get(apiUrl + '/bucket/FetchProposal?id=' + dutyId, { 'Content-Type' : 'application/json' })
            .then(callback);
        }

        /**
         * Fetches shared proposal info
         * @param {number} dutyId 
         * @param {number} sharedDutyId 
         * @param {function} callback
         * @returns {object} - Promise containing Proposed and Requested duties alongside Crew and Route details for each one
         */
        function fetchSharedProposal(dutyId, sharedDutyId, callback){
            return $http.get(apiUrl + '/bucket/FetchSharedProposal?dutyId=' + dutyId + '&sharedDutyId=' + sharedDutyId, { 'Content-Type' : 'application/json' })
            .then(callback);
        }

        /**
         * Creates/Sends Proposal
         * @memberof BucketFactory
         * @param {object} proposal - Containing proposedDutiesIdList and requestedDutiesIdList
         * @param {function} callback
         * @returns {object} - Promise containing updated proposal 
         */
        function createProposal(proposal, callback){
            return $http.post(apiUrl + '/bucket/CreateProposal', proposal, { 'Content-Type' : 'application/json' })
            .then(callback);
        }

        /**
         * Approves/Rejects proposal
         * @memberof BucketFactory
         * @param {object} proposal - Containing Id and isApproved
         * @param {function} callback
         * @returns {object} - Promise containing updated proposal 
         */
        function evaluateProposal(proposal, callback){
            return $http.put(apiUrl + '/bucket/EvaluateProposal/' + proposal.Id, proposal.isApproved, { 'Content-Type' : 'application/json' })
            .then(callback);
        }

        /**
         * Reverts proposal to previous status
         * @memberof BucketFactory
         * @param {number} proposalId 
         * @param {function} callback 
         * @returns {object} - Promise containing updated proposal
         */
        function undoProposalStatus(proposalId, callback){
            return $http.put(apiUrl + '/bucket/UndoProposalStatus/' + proposalId, { 'Content-Type' : 'application/json' })
            .then(callback);
        }

        return service;
    }
})();